<div class="mat-dialog-container">
  <!-- 明細編輯開始 -->
  <div #head>
    <app-modal-header #modal_header [isDialog]="isDialog" [title]="title" [state]="srv.state" (onOkClick)="doOk($event)"
      (onCancelClick)="doCancel($event)">
    </app-modal-header>
  </div>
  <div class="jk-content">
    <div class="jk-grid-cols-4"> 
    <app-jkbtnedit  maintable="STKMB" item="W01" valueExpr="MB001" displayExpr="MB002" 
 label="帳號代號" #MJ001Com  id="MJ001"  [(value)]="item.MJ001" [required]="true"  placeholder="帳號代號"  [readonly]="isBrowse"  (valueChange)="srv.MJ001Change(item)"     >
    </app-jkbtnedit>
    <app-jkedit  label="條件代號" #MJ002Com  id="MJ002"  [(value)]="item.MJ002" [required]="true"  placeholder="條件代號"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="名稱" #MJ003Com  id="MJ003"  [(value)]="item.MJ003" placeholder="名稱"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkcheckboxYN  label="啟用" #MJ019Com  id="MJ019"  [(valueYN)]="item.MJ019"  [readonly]="isBrowse"     >
    </app-jkcheckboxYN>
    <app-jkbtnedit  maintable="STKME" item="W01" valueExpr="ME001" displayExpr="ME002" 
 label="群組代號" #MJ005Com  id="MJ005"  [(value)]="item.MJ005" placeholder="群組代號"  [readonly]="isBrowse"  (valueChange)="srv.MJ005Change(item)"     >
    </app-jkbtnedit>
    <app-jkbtnedit  maintable="JCKMG" item="W01" valueExpr="MG002" displayExpr="MG003" 
 label="多空指標" #MJ006Com  id="MJ006"  [(value)]="item.MJ006" placeholder="多空指標"  [readonly]="isBrowse"     >
    </app-jkbtnedit>
    <app-jkcombobox  label="個股或群組" #MJ004Com  id="MJ004"  [(value)]="item.MJ004" [items]="srv.StkMj004List"  [readonly]="isBrowse"     >
    </app-jkcombobox>
    <app-jktextarea  height="250px" 
 label="條件說明" #MJ007Com  id="MJ007"  [(value)]="item.MJ007" placeholder="條件說明"  [readonly]="isBrowse"     >
    </app-jktextarea>
    <app-jknumberedit  label="成交量N張以上" #MJ016Com  id="MJ016"  [(value)]="item.MJ016" placeholder="成交量N張以上"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jknumberedit  label="間格時間(分)" #MJ022Com  id="MJ022"  [(value)]="item.MJ022" placeholder="間格時間(分)"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jknumberedit  label="保留" #MJ044Com  id="MJ044"  [(value)]="item.MJ044" placeholder="保留"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jknumberedit  label="保留" #MJ043Com  id="MJ043"  [(value)]="item.MJ043" placeholder="保留"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jktextarea  height="250px" 
 label="條件程式碼" #MJ027Com  id="MJ027"  [(value)]="item.MJ027" placeholder="條件程式碼"  [readonly]="isBrowse"     >
    </app-jktextarea>
    <app-jkedit  label="函數名1" #MJ029Com  id="MJ029"  [(value)]="item.MJ029" placeholder="函數名1"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jktextarea  height="250px" 
 label="參數1(JSON格式)" #MJ030Com  id="MJ030"  [(value)]="item.MJ030" placeholder="參數1(JSON格式)"  [readonly]="isBrowse"     >
    </app-jktextarea>
    <app-jkedit  label="函數名2" #MJ032Com  id="MJ032"  [(value)]="item.MJ032" placeholder="函數名2"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jktextarea  height="250px" 
 label="參數2" #MJ033Com  id="MJ033"  [(value)]="item.MJ033" placeholder="參數2"  [readonly]="isBrowse"     >
    </app-jktextarea>
    <app-jkedit  label="函數名3" #MJ035Com  id="MJ035"  [(value)]="item.MJ035" placeholder="函數名3"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jktextarea  height="250px" 
 label="參數3" #MJ036Com  id="MJ036"  [(value)]="item.MJ036" placeholder="參數3"  [readonly]="isBrowse"     >
    </app-jktextarea>
    <app-jkedit  label="函數名4" #MJ038Com  id="MJ038"  [(value)]="item.MJ038" placeholder="函數名4"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jktextarea  height="250px" 
 label="參數4" #MJ039Com  id="MJ039"  [(value)]="item.MJ039" placeholder="參數4"  [readonly]="isBrowse"     >
    </app-jktextarea>
    <app-jkedit  label="函數名5" #MJ041Com  id="MJ041"  [(value)]="item.MJ041" placeholder="函數名5"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jktextarea  height="250px" 
 label="參數5" #MJ042Com  id="MJ042"  [(value)]="item.MJ042" placeholder="參數5"  [readonly]="isBrowse"     >
    </app-jktextarea>
    <app-jknumberedit  label="排序" #MJ011Com  id="MJ011"  [(value)]="item.MJ011" placeholder="排序"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jknumberedit  label="保留" #MJ012Com  id="MJ012"  [(value)]="item.MJ012" placeholder="保留"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jknumberedit  label="保留" #MJ013Com  id="MJ013"  [(value)]="item.MJ013" placeholder="保留"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jknumberedit  label="保留" #MJ014Com  id="MJ014"  [(value)]="item.MJ014" placeholder="保留"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jknumberedit  label="保留" #MJ015Com  id="MJ015"  [(value)]="item.MJ015" placeholder="保留"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jknumberedit  label="保留" #MJ017Com  id="MJ017"  [(value)]="item.MJ017" placeholder="保留"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jknumberedit  label="保留" #MJ018Com  id="MJ018"  [(value)]="item.MJ018" placeholder="保留"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jktext  label="上次選股時間" [value]="item.MJ026"     >
    </app-jktext>
    <app-jkdatefield  label="上次選股日期" #MJ025Com  id="MJ025"  [(value)]="item.MJ025" placeholder="上次選股日期"  [readonly]="isBrowse" 
            >
    </app-jkdatefield>

    </div>
  </div>
</div>